import { render } from "./MentalHealthAssessmentModal.vue?vue&type=template&id=f720f574&scoped=true"
import script from "./MentalHealthAssessmentModal.vue?vue&type=script&lang=js"
export * from "./MentalHealthAssessmentModal.vue?vue&type=script&lang=js"

import "./MentalHealthAssessmentModal.vue?vue&type=style&index=0&id=f720f574&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f720f574"]])

export default __exports__